<template>
    <div class="panel panel-info" v-if="geocode">
        <!-- Default panel contents -->
        <div class="panel-heading"><i class="fa fa-terminal" aria-hidden="true"></i> LAT & LONG</div>
        <div class="panel-body">
            <div class="form-group">
                <div class="col-sm-4">
                    <label for="inputIp" class="control-label right">LATITUDE:</label><br/>
                    <input type="text" v-model="geocode.latitude" class="form-control" id="inputIp">
                </div>

                <div class="col-sm-4">
                    <label for="inputUsuario" class="control-label">LONGITUDE:</label><br/>
                    <input type="text" v-model="geocode.longitude" class="form-control" id="inputUsuario">
                </div>

                <div class="col-sm-4">
                    <label for="inputUsuario" class="control-label">&nbsp;</label><br/>
                    <button @click="setMarker()" type="button" class="btn btn-info btn-block">
                        VER NO MAPA
                    </button>
                </div>
            </div>
            <hr/>
            <div id="map" style="height: 300px"></div>
        </div>
    </div>
</template>
<script>
/* global L */
export default {
    props: {
        geocode: {
            default: null
        }
    },
    data() {
        return {
            ATTR:
                '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            CDB_URL:
                "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
            map: null,
            marker: null
        };
    },
    beforeDestroy() {
        this.map.off();
        this.map.remove();
        this.marker.remove();
        console.log("geocode off");
    },
    mounted() {
        this.map = L.map("map", {
            fullscreenControl: {
                pseudoFullscreen: false
            }
        });
        L.tileLayer(this.CDB_URL, { attribution: this.ATTR }).addTo(this.map);
        setTimeout(() => this.setMarker(), 200);
        // this.setMarker();
    },
    methods: {
        moved(e) {
            this.geocode.latitude = e.target._latlng.lat;
            this.geocode.longitude = e.target._latlng.lng;
        },
        setMarker() {
            if (!this.marker) {
                this.marker = L.marker(
                    [
                        this.geocode.latitude || -21.80149347,
                        this.geocode.longitude || -41.305208
                    ],
                    {
                        draggable: true
                    }
                );
                this.marker.on("dragend", e => this.moved(e));
                this.marker.addTo(this.map);
            }
            this.marker = this.marker.setLatLng(
                L.latLng(
                    this.geocode.latitude || -21.80149347,
                    this.geocode.longitude || -41.305208
                )
            );
            this.map.setView(
                [
                    this.geocode.latitude || -21.80149347,
                    this.geocode.longitude || -41.305208
                ],
                14
            );
        }
    }
};
</script>
